import type { FC } from 'react';
import { CommonButton } from '@shared/ui';
import { AuthForm } from '@src/modules/Authentication/AuthFrom';
import ButtonLink from '@src/modules/Authentication/ButtonLink/index.ts';
import { Captcha } from '@src/modules/Authentication/Captcha';
import CustomInput from '@src/modules/Authentication/CustomInput';
import { ModalError } from '@src/modules/Authentication/frames/modal-error';
import * as st from '../reset-phone-step/styles.module.scss';

interface Props {
  model: any;
}

export const ResetEmailStep: FC<Props> = ({ model }) => {
  const errorMessage: string =
    model.emailErrors?.email?.message || model.emailErrors?.root?.message;
  return (
    <AuthForm onSubmit={model.submitEmail((data: any) => model.checkedEmail(data.email))}>
      <CustomInput
        tabindex={0}
        type="text"
        label="E-mail"
        name="email"
        control={model.controlEmail}
        error={model.emailErrors?.email}
        disabled={model.isLoading}
        variant="outline"
        placeholder={''}
        onChange={model.cleanEmailErrors}
      />

      <ButtonLink
        className={st.buttonLink}
        disabled={model.isLoading}
        handler={model.openPhoneForm}
      >
        Восстановить через номер телефона
      </ButtonLink>

      <Captcha tabIndex={0} onChange={model.onCaptchaChange} className={st.captcha} />

      {errorMessage ? (
        <ModalError error={errorMessage} />
      ) : (
        <div className={st.wrapper}>
          <CommonButton tabIndex={0} type="submit" disabled={!model.isCaptchaVerified}>
            Запросить код
          </CommonButton>
        </div>
      )}
    </AuthForm>
  );
};
